// apps/web/src/components/agreements/AgreementsManager.tsx
// Agreement lifecycle management.

import { ManagerPage } from '../platform/ManagerPage.js';
import type { Agreement } from '../../types/platform.js';

export function AgreementsManager() {
  return (
    <ManagerPage
      title="Agreements"
      listPath="/api/v1/agreements"
      listKey="agreements"
      createLabel="New Agreement"
      className="agreements-manager"
      renderItem={(raw) => {
        const a = raw as Agreement;
        return (
          <div className="manager-card" key={a.id}>
            <h3>{a.agreementType}</h3>
            <p className="status-badge">{a.status}</p>
            <p>From {a.effectiveFrom ?? '—'} to {a.effectiveTo ?? '—'}</p>
            <div className="actions">
              <button className="btn btn-secondary">View</button>
              <button className="btn btn-warning">Amend</button>
              <button className="btn btn-primary">Sign</button>
            </div>
          </div>
        );
      }}
    />
  );
}